import Content from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Content/Content";
import TopRow from "@coworker/apprestructured/src/task-management/components/TaskCard/components/TopRow/TopRow";
import TaskType from "@coworker/apprestructured/src/task-management/components/TaskCard/components/TaskType/TaskType";
import BottomRow from "@coworker/apprestructured/src/task-management/components/TaskCard/components/BottomRow/BottomRow";
import Assigned from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Assigned/Assigned";
import Date from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Date/Date";
import { LOADING } from "@coworker/apprestructured/src/task-management/loading";
import LoadingCardFragments from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/LoadingCardFragments/LoadingCardFragments";

function LoadingTaskCard() {
  return (
    <Content>
      <TopRow>
        <TaskType value={LOADING} />
      </TopRow>
      <LoadingCardFragments />
      <BottomRow>
        <Assigned value={LOADING} />
        <Date value={LOADING} />
      </BottomRow>
    </Content>
  );
}

export default LoadingTaskCard;
